import { useEffect, useState } from 'react';
import { FREE } from 'self-service-api/constants/ProductLevels';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { buildFilteredHighlightedProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { getMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import { StyledCardGrid, borderStyle } from '../../merch-card/MerchCardSharedComponents';
import MobileProductLevelSelectorButtons from '../MobileProductLevelSelectorButtons';
import MobileSuiteFeatureTable from '../MobileSuiteFeatureTable';
import MobileSuiteFreeTile from './MobileSuiteFreeTile';
import { MobileSuiteTile } from './MobileSuiteTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const commonStyles = {
  paddingLeft: 28,
  paddingRight: 28,
  borderRight: borderStyle,
  borderLeft: borderStyle
};
const MobileSuiteTileContainer = ({
  selectedTab
}) => {
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab
  });
  const [selectedProductLevel, setSelectedProductLevel] = useState(productLevelsToShow[0]);
  useEffect(() => {
    if (!productLevelsToShow.includes(selectedProductLevel)) {
      setSelectedProductLevel(productLevelsToShow[0]);
    }
  }, [selectedTab, productLevelsToShow, selectedProductLevel]);
  const productsByProductLine = {
    [ProductLines.MARKETING]: buildFilteredHighlightedProducts({
      productLine: ProductLines.MARKETING,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.SALES]: buildFilteredHighlightedProducts({
      productLine: ProductLines.SALES,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.SERVICE]: buildFilteredHighlightedProducts({
      productLine: ProductLines.SERVICE,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.OPERATIONS]: buildFilteredHighlightedProducts({
      productLine: ProductLines.OPERATIONS,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.CMS]: buildFilteredHighlightedProducts({
      productLine: ProductLines.CMS,
      productLevels: [selectedProductLevel]
    })
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center justify-center m-x-auto",
    style: {
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx(MobileProductLevelSelectorButtons, {
      productLevels: productLevelsToShow,
      selectedProductLevel: selectedProductLevel,
      onClick: setSelectedProductLevel
    }), /*#__PURE__*/_jsx(StyledCardGrid, {
      columns: 1,
      children: selectedProductLevel === FREE ? /*#__PURE__*/_jsx(MobileSuiteFreeTile, {
        commonStyles: commonStyles
      }) : /*#__PURE__*/_jsx(MobileSuiteTile, {
        productLevel: selectedProductLevel,
        commonStyles: commonStyles
      })
    }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
      productsByProductLine: productsByProductLine,
      productLevel: selectedProductLevel
    })]
  });
};
export default MobileSuiteTileContainer;